import React from 'react';
import '../../less/order/result.less';

export default function template() {
  const text = this.props.type === 'kid-card' ? 'CARDS_ORDER_RESULT_DESC_2' : 'CARDS_ORDER_RESULT_DESC';
    return (
        <div className="module-cards-order-result">
            <div className="success">
                <div id="success-request" className="success-img" />
                <h2 className="success-heading">{this.l10n('CARDS_ORDER_RESULT_HEADING')}</h2>
                <div className="text-center">{this.l10n(text)}</div>
            </div>
        </div>
    );
}
